export default "__VITE_ASSET__KVGMtXoV__"